import plot1data from "./plot1data.js";
import plot1alt from "./plot1alt.js";
import plot1 from "./plot1.js";
import plot2 from "./plot2.js";
import plot3 from "./plot3.js";
import plot4 from "./plot4.js";
import plot5 from "./plot5.js";
import plot6 from "./plot6.js";
import alttext1 from "./alttext1.js";
import alttext2 from "./alttext2.js";
import alttext3 from "./alttext3.js";
import alttext4 from "./alttext4.js";
import alttext5 from "./alttext5.js";
import alttext6 from "./alttext6.js";

const plotFunctions = {
  plot1data: plot1data,
  plot1alt: plot1alt,
  plot1: plot1,
  plot2: plot2,
  plot3: plot3,
  plot4: plot4,
  plot5: plot5,
  plot6: plot6,
  alttext1: alttext1,
  alttext2: alttext2,
  alttext3: alttext3,
  alttext4: alttext4,
  alttext5: alttext5,
  alttext6: alttext6,
};

export default plotFunctions;
